import {DataContentWrapper} from '@hconnect/common/containers'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {RadioButtonChecked} from '@mui/icons-material'
import {Box, Chip, SxProps, Theme, Typography} from '@mui/material'
import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {KMS_WIDGET_NAMESPACE} from '../../consts'
import {useKilnMonitoringState} from '../../hooks'

import {KilnMonitoringPanel} from './KilnMonitoringPanel'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
  onSelectedKilnChange?: () => void
}

export const KilnMonitoringDataWidget: React.FC<Props> = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx,
  onSelectedKilnChange
}) => {
  const {t} = useTranslation(KMS_WIDGET_NAMESPACE)
  const {
    isLoading,
    kilnsInfo,
    selectedKiln,
    healthIndicators,
    sensorAreas,
    handleSelectedKilnChange
  } = useKilnMonitoringState(plantId)

  useEffect(() => {
    if (selectedKiln) {
      onSelectedKilnChange?.()
    }
  }, [selectedKiln, onSelectedKilnChange])

  return (
    <CardBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        ...cardBoxSx,
        px: 0,
        pl: 3
      }}
      data-test-id="kiln-monitoring-card"
    >
      <Box display="flex" flexDirection="row">
        <Box flex={1}>
          <Typography variant="h3" mb={2}>
            {t('kilnMonitoring.cardTitle')}
          </Typography>
        </Box>
        <Chip
          icon={<RadioButtonChecked />}
          label={t('label.live')}
          size="small"
          sx={{mx: 1, mr: 4}}
        />
      </Box>
      <DataContentWrapper
        showLoader={isLoading}
        isError={kilnsInfo.isError}
        isRefetching={kilnsInfo.isRefetching}
        data={selectedKiln}
        retryFunction={() => void kilnsInfo.refetch()}
        progressSx={{color: 'primary.main'}}
        placeholderWrapperSx={placeholderWrapperSx}
      >
        <Box sx={{flex: 1, overflowY: 'auto', pr: 3}}>
          <KilnMonitoringPanel
            isLoading={isLoading}
            kilns={kilnsInfo.data}
            selectedKiln={selectedKiln}
            isLoadingHealthIndicators={healthIndicators.isLoading}
            healthIndicators={healthIndicators.data}
            onSelectedKilnChange={handleSelectedKilnChange}
            isLoadingSensors={sensorAreas.isLoading}
            sensorAreas={sensorAreas.data}
          />
        </Box>
      </DataContentWrapper>
    </CardBox>
  )
}
